/* eslint-disable react/prop-types */
import { IconButton, Stack } from "@mui/material";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import Iconify from "./Iconify";

export function SocialShare({ title, url }) {
  const { asPath } = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  if (!url) url = `https://onthibanglaixe.net${asPath}`;

  const [SOCIALS] = useState([
    {
      name: 'Link',
      icon: <CopyToClipboard text={url} onCopy={() => enqueueSnackbar('Copied!')}><Iconify icon={'eva:copy-fill'} width={25} height={25} /></CopyToClipboard>,
    },
    {
      name: 'Linkedin',
      icon: <LinkedinShareButton url={url} title={title || url}><Iconify icon="eva:linkedin-fill" width={25} height={25} color="#006097" /></LinkedinShareButton>,
    },
    {
      name: 'Twitter',
      icon: <TwitterShareButton url={url} title={title || url}><Iconify icon="eva:twitter-fill" width={25} height={25} color="#1C9CEA" /></TwitterShareButton>,
    },
    {
      name: 'Facebook',
      icon: <FacebookShareButton url={url} title={title || url} quote={title || url}><Iconify icon="eva:facebook-fill" width={25} height={25} color="#1877F2" /></FacebookShareButton>
    }
  ]);

  return (
    <Stack direction={"row"} spacing={1} alignItems={"center"}>
      {SOCIALS.map((action) => (
        <IconButton key={action.name} aria-label={action.name} color="default">
          {action.icon}
        </IconButton>
      ))}
    </Stack>
  );
}